import React from 'react'
import { View, Text } from 'react-native'
import { deliStyles } from '../styles/deli';

const Delivery = () => {
  return (
    <View style={deliStyles.deliWrapper}>
      <Text style={deliStyles.delitext}>
        Thank you for making your order
      </Text>
    </View>
  );
}

export default Delivery